import type { AxiosResponse } from "axios";
import type { BankIdBaseResponse } from "@/stores/bank-id/bank-id-store.types";

export type BankIdRequestHandler = {
  setErrorMessage: (errorMessage: string | null) => void;
  setSuccessMessage: (successMessage: string | null) => void;
  setIsLoading: (loading: boolean) => void;
  __: (key: string) => string;
};

export async function withBankIdRequestHandling<T>(
  action: () => Promise<AxiosResponse<BankIdBaseResponse<T>>>,
  requestHandler: BankIdRequestHandler
): Promise<void> {
  const { setErrorMessage, setIsLoading, __ } = requestHandler;

  try {
    setErrorMessage(null);
    setIsLoading(true);

    const response: AxiosResponse<BankIdBaseResponse<T>> = await action();

    const { errors } = response.data;

    if (errors.message || errors.details) {
      setErrorMessage(errors.message || errors.details);

      return;
    }

    if (errors.code) {
      setErrorMessage(errors.message || errors.details);
    }
  } catch (err) {
    const errorMessage =
      err instanceof Error ? err.message : __("bank_id.error.description");

    setErrorMessage(errorMessage);
  } finally {
    setIsLoading(false);
  }
}
